import { ASSIGNMENT_TAG, createTagsForList, SHARE_SUGGESTION_TAG } from './utils/tags'
import {
    normalizeFetchAssignmentSharedWithResponse,
    normalizeFetchPendingShareSuggestionsResponse,
} from './utils/normalizers/shared-assignment.normalizers'
import baseApi from './base.api'

export const sharedAssignmentApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        fetchAssignmentSharedWith: builder.query({
            query: ({ token }) => ({
                url: `/shared-assignments/${token}/by-assignment`,
                method: 'GET',
            }),
            transformResponse: normalizeFetchAssignmentSharedWithResponse,
            providesTags: result => createTagsForList(result, ASSIGNMENT_TAG),
        }),
        shareAssignment: builder.mutation({
            query: ({ token, email, sharingLevel, shareWithOrganization }) => ({
                url: `/shared-assignments/${token}/share`,
                method: 'POST',
                body: {
                    email,
                    sharing_level: sharingLevel,
                    share_with_organization: shareWithOrganization,
                },
            }),
            invalidatesTags: [{ type: ASSIGNMENT_TAG, id: 'LIST' }],
        }),
        unshareAssignment: builder.mutation({
            query: ({ id }) => ({
                url: `/shared-assignments/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, arg) => [{ type: ASSIGNMENT_TAG, id: arg.id }],
        }),
        updateAssignmentSharingLevel: builder.mutation({
            query: ({ id, level }) => ({
                url: `/shared-assignments/${id}`,
                method: 'PATCH',
                body: {
                    sharing_level: level,
                },
            }),
            invalidatesTags: (result, error, arg) => [{ type: ASSIGNMENT_TAG, id: arg.id }],
        }),
        updateAssignmentSharingLevelForOrganization: builder.mutation({
            query: ({ token, level }) => ({
                url: `/shared-assignments/${token}/organization-sharing-level`,
                method: 'PUT',
                body: {
                    sharing_level: level,
                },
            }),
            invalidatesTags: [{ type: ASSIGNMENT_TAG, id: 'LIST' }],
        }),
        fetchPendingShareSuggestions: builder.query({
            query: () => ({
                url: `/shared-assignments/pending-requests`,
                method: 'GET',
            }),
            transformResponse: normalizeFetchPendingShareSuggestionsResponse,
            providesTags: result => createTagsForList(result, SHARE_SUGGESTION_TAG),
        }),
        acceptPendingShareSuggestion: builder.mutation({
            query: ({ id }) => ({
                url: `/shared-assignments/${id}/consider-share-request`,
                method: 'PUT',
                body: { accepted: true },
            }),
            invalidatesTags: (result, error, arg) => [
                { type: SHARE_SUGGESTION_TAG, id: arg.id },
                { type: ASSIGNMENT_TAG, id: 'LIST' },
            ],
        }),
        rejectPendingShareSuggestion: builder.mutation({
            query: ({ id }) => ({
                url: `/shared-assignments/${id}/consider-share-request`,
                method: 'PUT',
                body: { accepted: false },
            }),
            invalidatesTags: (result, error, arg) => [{ type: SHARE_SUGGESTION_TAG, id: arg.id }],
        }),
    }),
})

export const {
    useFetchAssignmentSharedWithQuery,
    useShareAssignmentMutation,
    useUpdateAssignmentSharingLevelMutation,
    useUnshareAssignmentMutation,
    useUpdateAssignmentSharingLevelForOrganizationMutation,
    useFetchPendingShareSuggestionsQuery,
    useAcceptPendingShareSuggestionMutation,
    useRejectPendingShareSuggestionMutation,
} = sharedAssignmentApi
